import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import SelectPhrases from "./SelectPhrases";
import SelectAnswers from "./SelectAnswers";
import Select from "react-select";
import Repo from "./Utility/Repo";
import Spinner from "react-bootstrap/Spinner";

function ModalEdit(props) {
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [loading, setLoading] = React.useState(false);

  const [tempData, setTempoData] = useState({
    parent: null,
    intent: null,
    phrases: [],
    answers: [],
    chips: [],
    endConv: props.itemsForEdit ? props.itemsForEdit.endConv : false,
  });

  const checkForm = () => {
    if (!tempData.parent) return false;
    else if (!tempData.intent || tempData.intent.length === 0) return false;
    else if (!tempData.intent || tempData.intent.length === 0) return false;
    else if (!tempData.phrases || tempData.phrases.length === 0) return false;
    else if (!tempData.answers || tempData.answers.length === 0) return false;

    return true;
  };
  const onSwitchAction = () => {
    setTempoData((prevState) => ({
      ...prevState,
      endConv: !isSwitchOn,
    }));

    setIsSwitchOn(!isSwitchOn);
  };

  const insertQuestion = (dato) => {
    setTempoData((prevState) => ({
      ...prevState,
      phrases: dato,
    }));
  };

  const insertAnswersn = (dato) => {
    setTempoData((prevState) => ({
      ...prevState,
      answers: dato,
    }));
  };

  // const insertChips = (dato) => {
  //   console.log('dato: ', dato);
  //   setTempoData((prevState) => ({
  //     ...prevState,
  //     chips: dato,
  //   }))
  //   console.log(tempData)
  // }

  const options = [
    { value: "SCNI", label: "Divorzio" },
    { value: "ADIE", label: "Matrimonio" },
    { value: "UFSCD", label: "Ufficiale di stato civile " },
    { value: "GDR", label: "Gestione dei registri " },
    { value: "ARDA", label: "Annotazioni e rettificazione degli atti" },
    { value: "ADA", label: "Atti di nascita" },
    { value: "ADNAR", label: "Atti di nascita - adozioni e riconoscimenti " },
    { value: "NC", label: "Nomi e cognomi " },
    {
      value: "CTCA",
      label:
        "Capacità della persona - tutela - curatela - amministrazione di sostegno ",
    },
    { value: "ADUC", label: "Atti di unione civile " },
    { value: "ADM", label: "Atti di morte " },
    { value: "CDIP", label: "Cittadinanza e diritto internazionale privato " },
    {
      value: "APRCI",
      label: "Iure sanguinis",
    },
    {
      value: "ACTDAG",
      label:
        "Atti di cittadinanza - trascrizioni - decreti - accertamenti – giuramenti ",
    },
    {
      value: "TASSC",
      label: "Trascrizione atti e sentenze stranieri e comunitari ",
    },
    {
      value: "CTLCP",
      label:
        "Convenzioni, traduzioni, legalizzazioni e certificati plurilingue ",
    },
  ];

  const setParent = (e) => {
    setTempoData((prevState) => ({
      ...prevState,
      parent: e.value,
    }));
  };

  const handleSubmite = () => {
    if (checkForm) {
      var obbj = {
        projectId: props.projectId,
        intentId: tempData.id,
        displayName: tempData.intent,
        trainingPhrases: tempData.phrases.map((x) => {
          return x;
        }),
        messageText: tempData.answers.map((x) => {
          return x;
        }),
        inputContextNames: [tempData.parent],
        endInteraction: isSwitchOn,
      };

      Repo.editIntents(JSON.stringify(obbj))
        .then(function (response) {
          props.eventShow(false);

          setLoading(true);

          window.location.reload();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (props.itemsForEdit) {
      setTempoData(props.itemsForEdit);
      setIsSwitchOn(props.itemsForEdit.endConv);
    }
  }, [props.itemsForEdit]);

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => props.onHide(false)}
        aria-labelledby="contained-modal-title-vcenter"
        animation={true}
        centered={true}
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Modifica l'Intent selezionato
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">
              <b>Seleziona Argomento</b>
            </label>

            {props.itemsForEdit && (
              <>
                <Select
                  options={options}
                  onChange={(e) => setParent(e)}
                  defaultValue={{
                    value:
                      // props.itemsForEdit.parent === "Matrimonio"
                      //   ? "ADIE"
                      //   : "SCNI",
                      options.filter(
                        (obj) => obj.label === props.itemsForEdit.parent
                      )[0].value,
                    label: props.itemsForEdit.parent,
                  }}
                />
              </>
            )}
          </div>

          {/* <div className="form-group mt-2">
          <label htmlFor="exampleInputEmail1"><b>Intent</b></label>
          <input
            className="form-control"
            id="Intent"

            disabled={(tempData.parent) ? "" : "disabled"}



            placeholder="Inserisci nome dell'intent"
            onChange={(e) =>
              setTempoData((prevState) => ({
                ...prevState,
                intent: e.target.value,
              }))
            }
            value={setTempoData.intent}
          />
          <small id="emailHelp" className="form-text text-muted">Inserisci un nome univoco per poter in futuro indetificare l'intent inserito</small>
        </div> */}

          {props.itemsForEdit && (
            <SelectPhrases
              value={props.itemsForEdit.phrases}
              setValue={insertQuestion}
              disabled={!false}
              editMode={true}
            ></SelectPhrases>
          )}

          {props.itemsForEdit && (
            <SelectAnswers
              value={props.itemsForEdit.answers}
              setValue={insertAnswersn}
              disabled={!false}
              editMode={true}
            ></SelectAnswers>
          )}

          <div className="form-group mt-4 pl-2">
            <div className="row">
              <div className="col-3">
                <label htmlFor="exampleInputEmail1">
                  <b>Fine Conversazione</b>
                </label>
              </div>
              <div className="col-3">
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  onChange={() => onSwitchAction()}
                  checked={isSwitchOn}
                  defaultChecked={false}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-6">
                <p style={{ fontSize: "13px" }}>
                  (Abilita il pulsante di Fine Conversazione in modo tale che il
                  numero di domande residue diminuisca dopo aver ricevuto
                  risposta a questa domanda.)
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            type="submit"
            onClick={() => handleSubmite()}
          >
            Conferma
          </Button>

          <Button variant="danger" onClick={props.onHide}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      {loading && (
        <div className="spinnerClass">
          <Spinner
            animation="grow"
            variant="light"
            style={{ width: "70px", height: "70px" }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
}

export default ModalEdit;
